import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import GuideDetailForm from '../Forms/GuideDetailForm';

const AddEditGuideDetailModal = ({
	finalDestinationSelected,
	residueType,
	dataGuideDetail,
	handleDataGuideDetail,
	isOpen,
	isEdit,
	handleIsEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	guideDetailsList,
	handlerGuideDetailsList
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Detalle de Residuo
			</ModalHeader>

			{/* <div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
					</NavItem>
				</Nav>
			</div> */}

			<GuideDetailForm
				finalDestinationSelected={finalDestinationSelected}
				residueType={residueType}
				dataGuideDetail={dataGuideDetail}
				handleDataGuideDetail={handleDataGuideDetail}
				isOpen={isOpen}
				isEdit={isEdit}
				handleIsEdit={handleIsEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				guideDetailsList={guideDetailsList}
				handlerGuideDetailsList={handlerGuideDetailsList}
			/>
		</Modal>
	);
};

export default AddEditGuideDetailModal;
